import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueSwal from 'vue-swal'
import VueSocketIO from 'vue-socket.io';
import SocketIO from 'socket.io-client'
import helpers from './helpers'
import FBSignInButton from 'vue-facebook-signin-button'
import Sticky from 'vue-sticky-directive'
import 'animate.css/animate.css'
import store from './store'
import money from 'v-money'
import VueConfetti from 'vue-confetti'
import OneSignalVue from 'onesignal-vue'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import {version} from '../package'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../../assets/css/main.css'
import 'leaflet/dist/leaflet.css';

const environment = process.env.VUE_APP_ENVIRONMENT ? process.env.VUE_APP_ENVIRONMENT : 'production';

if (environment === 'production') {
  Sentry.init({
    Vue: Vue,
    environment: environment,
    dsn: "https://9d16d05505974beb84adafc2cc03fd99@o449432.ingest.sentry.io/5851645",
    integrations: [new Integrations.BrowserTracing({
      tracingOrigins: [/^\//],
    })],

    tracesSampleRate: environment === 'production' ? 0.2 : 1,
    logErrors: environment !== 'production',
    attachProps: true,
    attachStacktrace: true,

    beforeSend(event, hint) {
      if (hint.originalException === "Timeout") return null;
      return event;
    }
  });
}

// const base_socket = "https://lecard-node-server-dgdmx.ondigitalocean.app";
// const connection = SocketIO(base_socket + '/delivery');
// Vue.use(new VueSocketIO({ debug: false, connection }));
const base_socket = "https://region-one.socket.storkdigital.com.br/delivery";
Vue.use(new VueSocketIO({ debug: false, connection: base_socket }));
Vue.use(VueSwal);
Vue.use(helpers);
Vue.use(VueResource);
Vue.use(FBSignInButton);
Vue.use(Sticky);
Vue.use(VueConfetti);
Vue.use(OneSignalVue);
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false
});

Vue.config.productionTip = false;

Vue.filter('valor', function (value) {
  if (value === undefined || value === null) {
    return value;
  }
  let formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.filter('getDay', function (value) {
  if (value === undefined || value === null) {
    return value;
  }

  switch (value) {
    case "1":
      return "Domingo";
    case "2":
      return "Segunda-Feira";
    case "3":
      return "Terça-Feira";
    case "4":
      return "Quarta-Feira";
    case "5":
      return "Quinta-Feira";
    case "6":
      return "Sexta-Feira";
    case "7":
      return "Sábado";
    default:
      return value
  }
});

Vue.filter('percent', function (value) {
  if (value !== null || value !== undefined) {
    return parseFloat(value).toFixed();
  }
});

Vue.filter('kilometer', function (value) {
  if (value !== null || value !== undefined) {
    const formated = parseFloat(value / 1000).toFixed(1);
    return formated + ' km';
  }
});

Vue.filter('maskPhone', function (phone) {
  if (phone && !isNaN(phone)) {
    if (phone.length === 10) {
      return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

    } else if (phone.length === 11) {
      return phone.replace(/[^0-9]/g, '')
        .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
  }

  return phone
});

Vue.filter('tempo', function (value) {
  if (!isNaN(value)) {
    value = parseInt(value || '0');

    if (!value) {
      return `Hoje`;

    } else {
      return value >= 1440 ? `${(value / 1440).toFixed()} dia${value > 2159 ? 's' : ''}` : `${value} mins`;
    }
  }
});

let domain = process.env.VUE_APP_DOMAIN || null;

// config antiga
if (!domain) {
  const base_assets = (process.env.VUE_APP_BASE_ASSETS || '').split('/');
  domain = (base_assets[base_assets.length - 1] || 'leblend')
}

const base_server = getAmbiente() + '/delivery/';
const base_cdn = 'https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-corporativo';
const base_assets = `${base_cdn}/companies/${domain}`;
const ocultar_cidade = process.env.VUE_APP_OCULTAR_CIDADE === 'true';

function getAmbiente() {
  const server = localStorage.getItem('ambiente') || process.env.VUE_APP_AMBIENTE || null;

  switch (server) {
    case '4':
      return 'http://localhost/lecard-server';

    case '3':
      return 'https://dev.lecard.app.br';

    case '2':
      return 'https://beta.lecard.app.br';

    default:
      return 'https://api.lecard.app.br';
  }
}

Vue.mixin({
  data() {
    return {
      app_version: version,
      oneSignalIntegration: (process.env.VUE_APP_ONE_SIGNAL_ID !== undefined),
      franquiasEnabled: (process.env.VUE_APP_FRANQUIA === 'true'),
      origin: '1',

      base_cdn,
      base_assets,
      server: base_server,
      empresaToken: process.env.VUE_APP_TOKEN,

      isAndroid: /(android)/i.test(navigator.userAgent),
      isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
      android_installed: !!(document.referrer.includes('android-app://') || sessionStorage.getItem('android-app')),
      ios_installed: (window.navigator.standalone === true),
      isInstagram: navigator.userAgent.includes("Instagram"),

      img_default: (base_cdn + '/static/imgs/default.png'),
      modo_catalogo: false,
      ocultar_cidade
    }
  },

  methods: {
    setSentry(data) {
      Sentry.setUser(data);
    }
  }
});

Vue.http.options.emulateJSON = true;
Vue.http.options.emulateHTTP = true;
Vue.http.options.root = base_server;

new Vue({
  el: '#app',
  router,
  directives: {Sticky},
  store,
  render: h => h(App),
  beforeMount() {
    if (process.env.VUE_APP_ONE_SIGNAL_ID) {
      this.$OneSignal.init({ appId: process.env.VUE_APP_ONE_SIGNAL_ID });
    }
  }
});
